<template>
  <img :src="url" alt="" />
</template>

<script>
import imageURLDecrypt from "@/imageURLDecrypt.js";

export default {
  name: "ImageDecrypt",
  data() {
    return {
      url: require("@/assets/img/px3.png"),
    };
  },
  props: {
    src: String,
  },
  methods: {},
  async mounted() {
    if (this.src) {
      this.url = await imageURLDecrypt(
        `https://lm8qlnns.7exgow.pro${this.src}`
      );
    }
  },
};
</script>

<style scoped lang="scss"></style>
